import React from 'react';
import {
  addPathToList,
  Configure_transfer_confirmation, getSubCategoryId, Payment_confirmation,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================
const Panel_F10_RequestPaymentConfirmation = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'does_it_look_ok',
    'confirm',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Payment_confirmation}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/confirmation/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/confirmation/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Configure_transfer_confirmation}
      language={language}
      paragraphMarginBottom={30}
    />
  );
};

export default Panel_F10_RequestPaymentConfirmation;
